import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AssetDto, GalleryDto, GalleryTheme } from '@nusign/picflow-backend-types';
import { VideoViewerComponent } from '../../../../gallery-shared/components/video-viewer/video-viewer.component';
import { CanDisplayAssetPipe } from '../../../../gallery-shared/pipes/can-display-asset.pipe';
import { AssetUrlPipe } from '../../../../shared/pipes/asset-url.pipe';
import { GalleryCoverUrlPipe } from '../../../../shared/pipes/gallery-cover-url.pipe';
import { CoverToVideoDataPipe } from '../../../pipes/cover-to-video-data.pipe';
import { VideoOriginPipe } from '../../../pipes/video-origin.pipe';

@Component({
  selector: 'app-cover-design-asset',
  imports: [
    AssetUrlPipe,
    VideoOriginPipe,
    CoverToVideoDataPipe,
    VideoViewerComponent,
    GalleryCoverUrlPipe,
    CanDisplayAssetPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './cover-design-asset.component.html',
  styleUrl: './cover-design-asset.component.scss',
})
export class CoverDesignAssetComponent {
  theme = input.required<GalleryTheme>();
  gallery = input.required<GalleryDto>();
  previewAsset = input<AssetDto>();
  allowEmptyStyle = input<boolean>();
  noAsset = input<boolean>();
  animated = input<boolean>();
}
